import Vue from 'vue'
import Router from 'vue-router'
let routes = [
    { path: '/', component: () => import('../components/Login.vue'), },
    { path: '/login', component: () => import('../components/Login.vue'), },
    {
        path: '/index',
        component: () => import('../components/Index.vue'),
        children: [
            { path: '/Home', components: { mainView: () => import('../components/Common/Home.vue') }, meta: { title: "首页" } },
        ],
    },
];
let localTree = JSON.parse(localStorage.getItem(`vue_tree`));
if (localTree && localTree.length > 0) {
    localTree.forEach(item => {
        let addRouter = {
            path: item.Router,
            components: { mainView: () => require.ensure([], (require) => require(`@/${item.LoadPath}`)) },
            meta: { title: item.MetaTitle }
        }
        routes[2].children.push(addRouter);
    });
}
Vue.use(Router)
export default new Router({
    routes: routes,
});





// WEBPACK FOOTER //
// ./src/router/index.js